// riskColors.js
export const riskPriorityColors = {
    Critical: '#000000',    // Black
    High: '#FF1744',        // Red
    Significant: '#FFC107', // Amber
    Moderate: '#FFA726',    // Light Orange
    Low: '#2196F3',         // Blue
    Negligible: '#4CAF50',  // Green
    None: '#BDBDBD',        // Light Grey
  };